import { PaymentServiceAccountStatus } from "@clipboard-health/contract-worker-app-bff";

export interface PayrollSettingsDropdownProps {
  balance: Balance;
  currentPaySchedule: LegacyClipboardPaySchedule;
  onPayScheduleChange: (schedule: LegacyClipboardPaySchedule) => void;
}

export interface Balance {
  availableNow: number;
  availableNowMinusFee: number;
  availableSoon: number;
  hasDebitCard: boolean;
  withdrawalFee: number;
  autoWithdrawEnabled: boolean;
}

export interface BubbleProps {
  icon: string;
  description: string;
  loading: boolean;
  value: React.ReactNode;
  dropdown?: React.ReactNode;
  valueFontSize?: number;
  storeHideDropDown?: (callback: () => void) => () => void;
}

export interface PayrollItemProps {
  icon: string;
  name: string;
  onClick: () => void;
}

export interface ChevronProps {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
  description: string; // for test-id
  ariaLabel: string;
}

export const InvalidPaymentAccountStatus = [
  PaymentServiceAccountStatus.INSTANT_PAYOUT_PENDING,
  PaymentServiceAccountStatus.STANDARD_PAYOUT_PENDING,
];

/**
 * @deprecated use PayoutSchedule from @src/appV2/redesign/Accounts/PayoutSettings/api/schema instead
 */
export type LegacyClipboardPaySchedule = "daily" | "instantly";

export interface ShiftDetailForBonus {
  _id: string;
  name: string;
  facility: {
    tmz: string;
    name: string;
  };
  start: string;
  end: string;
}
